'use strict';

namespace Core {

    class SelectedInsuranceSummary {

        insurance: any;

        public quote :Core.Insurance.InsuranceQuote;
        public show :boolean = false;

        constructor(
            private $scope: ng.IScope
        ) {

            let stop = this.$scope.$watch('sis.insurance', v => {
                if (v) {
                    this.init(v);
                    stop();
                }
            });

        }

        private init(insurance :any) :void {
            this.quote = insurance.Details.InsuranceQuotes[0];
            this.show = true;
        }

    }

    angular
        .module('core')
        .directive('selectedInsuranceSummary', (): ng.IDirective => {

        return {
            scope: {},
            controller: SelectedInsuranceSummary,
            controllerAs: 'sis',
            replace: true,
            bindToController: {
                insurance: '=',
                titleText: '@'
            },
            templateUrl: 'partials/home/directivetemplate?type=SelectedInsuranceSummary'
        };

    });

}
